import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HistoryState } from 'types';

export const initialState: HistoryState = {
  loading: false,
  uploads: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  filter: { type: 'SalesData' },
  reset: true,
  lastSync: ''
};

const slice = createSlice({
  name: 'Uploads',
  initialState,
  reducers: {
    setUploads: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.uploads = payload || [];
      state.reset = false;
    },
    setTotalCount: (state, { payload }: PayloadAction<any>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.currentPage = payload;
    },
    setPageSize: (state, { payload }: PayloadAction<any>) => {
      state.pageSize = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
    setLastSyncTime: (state, { payload }: PayloadAction<any>) => {
      state.lastSync = payload?.lastSyncTime;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const {
  setUploads,
  setTotalCount,
  setCurrentPage,
  setPageSize,
  setFilter,
  setLastSyncTime,
  reset
} = slice.actions;

export default slice.reducer;
